<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
    >
      <div class="pb-6">
        <h2
          class="display-1"
        >Menu</h2>
      </div>

      <v-row>
        <v-col
          cols="3"
        >
          <v-card>
            <v-card-title>Level 0</v-card-title>

            <v-card-text>
              <Menu
                class="menu-level-0"
                :level="0"
                :pages="pages"
              ></Menu>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="3">
          <v-card>
            <v-card-title>Level 1</v-card-title>

            <v-card-text>
              <Menu
                class="menu-level-1"
                v-if="selectedMenu[0]"
                :level="1"
                :parentId="selectedMenu[0]"
                :pages="pages"
              ></Menu>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="3">
          <v-card>
            <v-card-title>Level 2</v-card-title>

            <v-card-text>
              <Menu
                class="menu-level-2"
                v-if="selectedMenu[1]"
                :level="2"
                :parentId="selectedMenu[1]"
                :pages="pages"
              ></Menu>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="3">
          <v-card>
            <v-card-title>Level 3</v-card-title>

            <v-card-text>
              <Menu
                class="menu-level-3"
                v-if="selectedMenu[2]"
                :level="3"
                :parentId="selectedMenu[2]"
                :pages="pages"
              ></Menu>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="menuDialog"
      max-width="500"
      persistent
    >
      <v-card
        v-if="currentMenu"
        tag="form"
        @submit.prevent="$store.dispatch('Menus/validateMenu')"
      >
        <v-card-title
          class="headline"
        >Edit menu</v-card-title>

        <v-card-text>
          <v-text-field
            v-model="currentMenu.name"
            label="Name"
          ></v-text-field>

          <Combobox
            v-model="currentMenu.page_id"
            :select-props="{
              items: _pages,
              label: 'Page',
              clearable: true
            }"
            disableCreation
          ></Combobox>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="error"
            @click="$store.dispatch('Menus/removeMenu')"
            depressed
          >Supprimer</v-btn>

          <div class="flex-grow-1"></div>

          <v-btn
            color="primary"
            text
            @click="$store.commit('Menus/closeMenuDialog')"
          >Cancel</v-btn>

          <v-btn
            color="primary"
            type="submit"
            depressed
          >Validate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import Menu from '../components/Menu.vue'
import Combobox from '../components/Combobox.vue'

export default {
  components: {
    ApplicationLayout,
    Menu,
    Combobox
  },
  computed: {
    ...mapState('Menus', [
      'selectedMenu',
      'menuDialog',
      'currentMenu'
    ]),
    ...mapState('Pages', ['pages']),
    _pages() {
      return this.pages.map((page) => {
        return {
          value: page.id,
          text: this.$filters.striptags(page.title)
        }
      })
    }
  },
  created() {
    this.$store.dispatch('Menus/getAll')
    this.$store.dispatch('Pages/getAll')
  }
}
</script>
